import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import MUIDataTable from "mui-datatables";
import { API_URL } from '../../config';
import axios from 'axios';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';

import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import { pathSpliter, checkAuthBranchWare, dateTimeFormat } from '../../lib/functions'
import { currentRouteSet, createdTransportNameSet, updatedTransportNameSet, disableRestoreTransportNameSet } from '../../actions/actions';
import moment from 'moment';

const TransportNamesManage = ({ location, currentRouteSet, authInfo, createdTransportName, updatedTransportName, transportNameDisableRestoreAction,
  createdTransportNameSet, updatedTransportNameSet, disableRestoreTransportNameSet }) => {
  const classes = useStyles();
  let [formValues, formSetValues] = useState({ transport_name: '', transport_name_id: 0, action: 'create' });
  let [loadingSave, loadingSaveSet] = useState(false)
  let [loadingList, loadingListSet] = useState(false)
  let [transportNames, transportNamesSet] = useState([])
  let [transportNameUpdateIndex, transportNameUpdateIndexSet] = useState('0')

  const [successMsg, setSuccessMsg] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
    msg: ''
  });

  const { vertical, horizontal, open, msg } = successMsg;
  const handleClose = () => {
    setSuccessMsg({ ...successMsg, open: false });
  };
  useEffect(() => {
    createdTransportNameSet(null)
    updatedTransportNameSet(null)
    disableRestoreTransportNameSet(null)
  }, []);

  useEffect(() => {

    currentRouteSet(pathSpliter(location.pathname, 1));
    getTransportNames();
  }, []);

  useEffect(() => {
    if (createdTransportName) {
      if (checkAuthBranchWare(createdTransportName.user_branch_id)) {
        transportNamesSet((prev) => createdTransportName.createdRow.concat(prev));
        setSuccessMsg({ ...successMsg, msg: `${createdTransportName.msg}`, open: true });
        formSetValues({ transport_name: '', transport_name_id: 0, action: 'create' })
      }
    }
  }, [createdTransportName])

  useEffect(() => {
    if (updatedTransportName) {
      if (checkAuthBranchWare(updatedTransportName.user_branch_id)) {
        transportNamesSet((prev) =>
          prev.map((item, idx) =>
            idx === Number(updatedTransportName.index) ? updatedTransportName.updatedRow[0] : item
          )
        );
        setSuccessMsg({ ...successMsg, msg: `${updatedTransportName.msg}`, open: true });
        formSetValues({ transport_name: '', transport_name_id: 0, action: 'create' })
      }
    }
  }, [updatedTransportName])

  useEffect(() => {
    if (transportNameDisableRestoreAction) {
      if (checkAuthBranchWare(transportNameDisableRestoreAction.user_branch_id)) {
        transportNamesSet((prev) =>
          prev.map((item, idx) =>
            idx === Number(transportNameDisableRestoreAction.index)
              ? transportNameDisableRestoreAction.disableRestoreRow[0]
              : item
          )
        );
        setSuccessMsg({ ...successMsg, msg: `${transportNameDisableRestoreAction.msg}`, open: true });
      }
    }
  }, [transportNameDisableRestoreAction]);

  const handleFromInput = (e) => {
    const { name, value } = e.target;
    formSetValues({ ...formValues, [name]: value })
  }
  const saveFormAction = async () => {
    if (formValues.transport_name.trim() == '') {
      swal({
        title: 'Product  name is required',
        icon: 'warning'
      })
    } else {
      formValues.transportNameUpdateIndex = transportNameUpdateIndex
      formValues.transport_name = formValues.transport_name.trim()
      loadingSaveSet(true)
      await axios.post(`${API_URL}/api/transport-name-cu`, formValues, { headers: { 'auth-token': authInfo.token } }).then(async (res) => {
        loadingSaveSet(false)
        if (res.data.error) {
          swal({
            title: res.data.message,
            icon: 'warning'
          });
          return false;
        }
        // Always re-fetch latest list so UI updates immediately after create/update
        await getTransportNames();
        formSetValues({ transport_name: '', transport_name_id: 0, action: 'create' })
      }).catch((err) => {
        loadingSaveSet(false)
        swal({
          title: err?.response?.data?.message || err?.message || 'Failed to save transport name',
          icon: 'error'
        });
      })
    }
  }

  const transportNameEdit = (row, index) => {
    formValues.transport_name = transportNames[index].transport_name
    formValues.action = 'update'

    formSetValues({
      ...formValues, transport_name: transportNames[index].transport_name,
      transport_name_id: transportNames[index].transport_name_id
    });
    transportNameUpdateIndexSet(index)
  }
  const transportNameDisableRestore = async (transportNameId, actionCond, index) => {
    await axios
      .post(
        `${API_URL}/api/transport-name-disable-restore`,
        { transport_name_id: transportNameId, action: actionCond, index },
        { headers: { 'auth-token': authInfo.token } }
      )
      .then(async (res) => {
        if (res?.data?.error) {
          swal({
            title: res.data.message || 'Failed to update transport status',
            icon: 'warning'
          });
          return false;
        }
        // Always re-fetch latest list so UI updates immediately after delete/restore
        await getTransportNames();
      })
      .catch((err) => {
        swal({
          title: err?.response?.data?.message || err?.message || 'Failed to update transport status',
          icon: 'error'
        });
      });
  }
  const confirmAndDisableTransportName = async (transportNameId, index) => {
    const confirmDelete = await swal({
      title: 'Are you sure you want to delete this transport name?',
      text: 'If you delete it, this item will be disabled.',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true
    });

    if (!confirmDelete) return;
    await transportNameDisableRestore(transportNameId, 'disable', index);
  }

  const getTransportNames = async () => {
    loadingListSet(true)
    await axios.post(`${API_URL}/api/get-transport-names`, null, { headers: { 'auth-token': authInfo.token } }).then(res => {
      loadingListSet(false)
      transportNamesSet(res.data.message)
    })
  }


  const ActionOptions = (props) => {
    return (<div style={{ textAlign: 'right' }}>
      {
        authInfo.role != 'user' ? (
          <>
            <EditIcon style={{ cursor: 'pointer', fontSize: '28px', color: 'rgb(15, 126, 119)' }} onClick={() => transportNameEdit(props.rowData[0], props.rowIndex)} />
            {props.rowData[1] == 'active' ? (
              <DeleteIcon style={{ cursor: 'pointer', color: '#ff0202', fontSize: '28px' }} onClick={() => confirmAndDisableTransportName(props.rowData[0], props.rowIndex)} />
            ) : (
              <SettingsBackupRestoreIcon style={{ cursor: 'pointer', color: 'rgb(60, 178, 194)', fontSize: '28px', }} onClick={() => transportNameDisableRestore(props.rowData[0], 'restore', props.rowIndex)} />
            )}
          </>) : ''
      }

    </div>)

  }

  const columns = [
    { name: "transport_name_id", options: { display: 'excluded' } },
    { name: "transport_name_status", options: { display: 'excluded' } },
    { name: "transport_name", label: "Transport name", options: { filter: true, sort: true } },
    {
      name: "transport_name_created_isodt", label: "created date & time",
      options:
      {
        filter: true, sort: true,
        customBodyRender: (value, tableMeta) => {
          return (<p>{moment(tableMeta.rowData[3]).format(dateTimeFormat)}</p>)
        }
      }
    },
    {
      name: "transport_name_updated_isodt", label: "updated date & time", options:
      {
        filter: true, sort: true,
        customBodyRender: (value, tableMeta) => {
          return (<p>{moment(tableMeta.rowData[4]).format(dateTimeFormat)}</p>)
        }
      }
    },

    {
      name: "actions", options: {
        filter: false, sort: false,
        customBodyRender: (value, tableMeta) => {
          return (<ActionOptions value={value} rowIndex={tableMeta.rowIndex} rowData={tableMeta.rowData}
          />);
        }
      }, headerStyle: {
        textAlign: 'right'
      }
    }
  ];

  const options = {
    filterType: 'checkbox',
    selectableRows: 'none',
    display: "excluded"
  }

  return (
    <div className={classes.root}>
      {/* Success message */}
      <Snackbar open={open} autoHideDuration={10000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success">
          {successMsg.msg}
        </Alert>
      </Snackbar>
      {/* End of message */}
      <Paper className={classes.paper} style={{ marginTop: '-15px' }}>
        <h2 className={classes.pageEntryLabel}> Transport Name Entry</h2>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} style={{ margin: '0px auto' }}>
            <TextField autoComplete='off' className={classes.fullWidth} value={formValues.transport_name}
              label="transport name" name="transport_name" variant="outlined" size="small" onChange={handleFromInput} />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Button style={{ marginTop: '25px' }}
            variant="contained"
            color="primary"
            size="small"
            className={classes.button}
            startIcon={<SaveIcon />}
            disabled={loadingSave}
            onClick={saveFormAction}
          >
            Save
          </Button>
        </Grid>
      </Paper>
      {
        loadingList == true ? (<b>Loading...</b>) : (
          <Paper className={classes.paper} style={{ marginTop: '20px' }}>
            <MUIDataTable
              title={"Product List"}
              data={transportNames}
              columns={columns}
              options={options}
              adjustForCheckbox={false}
              displaySelectAll={false}
            />
          </Paper>
        )

      }
    </div>
  )
}



const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  root: {},
  '& .MuiTextField-root': {
    margin: theme.spacing(1),
    width: '25ch',
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  pageEntryLabel: {
    color: '#7754cc',
    margin: '0px',
    padding: '0px',
    marginTop: '-11px',
    textAlign: 'left',
    marginLeft: '0px',
    marginBottom: '5px',
    textAlign: 'center'
  },
  fullWidth: {
    width: '100%'
  },
  option: {
    fontSize: 15,
    '& > span': {
      marginRight: 10,
      fontSize: 18,
    },
  }
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
    createdTransportName: state.createdTransportNameReducer,
    updatedTransportName: state.updatedTransportNameReducer,
    transportNameDisableRestoreAction: state.transportNameDisableRestoreReducer
  }
}
export default connect(mapStateToPops, { currentRouteSet, createdTransportNameSet, updatedTransportNameSet, disableRestoreTransportNameSet })(TransportNamesManage);
